export default {
  next: {
    id: 'onboarding.next.button',
    defaultMessage: 'Next',
  },
  getStarted: { id: 'onboarding.getstarted.button', defaultMessage: 'Get started' },
};
